export const TYPOGRAPHY_VARIANTS = {
    largeTitle: ['font-heading', 'text-32', 'font-normal', 'leading-10', 'tracking-normal'],
    h1: ['font-heading', 'text-28', 'font-normal', 'leading-8', 'tracking-normal'],
    h2: ['font-heading', 'text-24', 'font-normal', 'leading-8'],
    h3: ['font-heading', 'text-22', 'font-normal', 'leading-8'],
    headline: ['font-heading', 'text-[1.0625rem]', 'font-normal', 'leading-6'],
    hugeBody: ['font-sans', 'text-32', 'leading-10'],
    body: ['font-sans', 'text-16', 'leading-6'],
    callout: ['font-sans', 'text-14', 'leading-5'],
    footnote: ['font-sans', 'text-[0.8125rem]', 'leading-4'],
    caption: ['font-sans', 'text-12', 'leading-4'],
    label: ['font-sans', 'text-11', 'leading-4', 'tracking-[1px]', 'uppercase'],
};
